export const RESET_ACCOUNTLY_STATE = 'accountly/resetState';
